module.exports = __webpack_public_path__ + "static/media/LoginBackgroundImage.4e7ce9e2.jpg";